<template>
    <el-row class="m-0 width-100-p height-100-p">
      <el-col
        class="d-flex align-item-center p-2"
        :span="
          $vuetify.display.width >= 768
            ? 8
            : 24
        "
      >
        <div
          class="row m-0 py-3 width-100-p height-100-p bg-me-primary border-color-light rounded-4"
        >
          <el-col :span="24" class="px-3 y-center">
            <h5 class="text-white">{{ dashboardData.total_usage_mwh.title }}</h5>
          </el-col>
          <el-col :span="6" class="x-y-center">
            <el-image
              :src="require('@/assets/images/dashboard/home/KilometerDriven.png')"
              fit="cover"
            />
          </el-col>
          <el-col :span="18" class="y-center">
            <div class="width-100-p p-2">
              <p class="font-20-b text-white mb-0">
                {{ dashboardData.total_usage_mwh.value == null ? "" : dashboardData.total_usage_mwh.value.toLocaleString() }}
              </p>
            </div>
          </el-col>
        </div>
      </el-col>
      <el-col
        class="d-flex align-item-center p-2"
        :span="
          $vuetify.display.width >= 768
            ? 8
            : 24
        "
      >
        <div
          class="row m-0 py-4 width-100-p bg-me-primary border-color-light rounded-4"
        >
          <el-col :span="24" class="px-3 y-center">
            <h5 class="text-white">
              {{ dashboardData.total_abatement_tco2.title }}
            </h5>
          </el-col>
          <el-col :span="6" class="x-y-center">
            <el-image
              :src="require('@/assets/images/dashboard/home/NoxSox.png')"
              fit="cover"
            />
          </el-col>
          <el-col :span="18" class="y-center">
            <div class="width-100-p p-2">
              <p class="font-20-b text-white mb-0">
                {{ dashboardData.total_abatement_tco2.value == null ? "" : dashboardData.total_abatement_tco2.value.toLocaleString() }}
              </p>
            </div>
          </el-col>
        </div>
      </el-col>
      <el-col
        class="d-flex align-item-center p-2"
        :span="
          $vuetify.display.width >= 768
            ? 8
            : 24
        "
      >
        <div
          class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
        >
          <el-col :span="24" class="px-3 y-center">
            <h5 class="text-white">
              {{ dashboardData.num_of_sites.title }}
            </h5>
          </el-col>
          <el-col :span="6" class="x-y-center">
            <el-image
              :src="require('@/assets/images/dashboard/home/FuelAvoided.png')"
              fit="cover"
            />
          </el-col>
          <el-col :span="18" class="y-center">
            <div class="width-100-p p-2">
              <p class="font-20-b text-white mb-0">
                {{ dashboardData.num_of_sites.value == null ? "0" : dashboardData.num_of_sites.value.toLocaleString() }}
              </p>
            </div>
          </el-col>
        </div>
      </el-col>
    </el-row>
  </template>
  
  <script>
  export default {
    props: {
    //   dataProp: {
    //     type: Object,
    //     default(rawProps) {
    //         console.log(rawProps);
            
    //       return rawProps.total_list;
    //     },
    //   },

    cardProp: {
        type: Array,
        default: null,
      },
    },
    components: {
      // ShowDetail,
    },
    data() {
      return {
        show: true,
        dashboardData: {
            total_usage_mwh: { title: "Total usage (MWh)", value: "0" },
            total_abatement_tco2: { title: "Total abatement (tCO2-e)", value: "0" },
            num_of_sites: { title: "Number of sites", value: "0" },
        },
        total_list: null,
      };
    },
    watch: {
        cardProp: {
            handler: function (newValue) {
                // console.log("newValue", newValue);
                
                this.total_list = newValue;
                // console.log("total_list", this.total_list);
                
                this.dashboardData.total_usage_mwh.value = newValue[0].total_usage_mwh;
                this.dashboardData.total_abatement_tco2.value = newValue[0].total_abatement_tco2;
                this.dashboardData.num_of_sites.value = newValue[0].num_of_sites;
            },
            deep: true,
      },
    },
    methods: {},
  };
  </script>
  